import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const removeScheduleTailoredAudits = api(function removeScheduleTailoredAudits(referenceId) {
    return mutate(
        gql`
            mutation RemoveScheduleTailoredAudits($referenceId: String!) {
                removeScheduleTailoredAudits(referenceId: $referenceId)
            }
        `,
        { referenceId },
        { returns: "removeScheduleTailoredAudits" }
    )
})
